import React from 'react';

import Icon from '../../../molecules/Icon';

import { color } from '../../../atoms/colors';

import { Container, Info, Circle } from './styles/index.styled';

const ContactCard = ({ heading = 'Contact Us:', email, phoneNumber }) => {
  if (!email && !phoneNumber) return null;

  return (
    <Container>
      <p className="heading">{heading}</p>
      <Info>
        {email && (
          <a href={`mailto:${email}`} className="email">
            <Circle>
              <Icon
                id="mail-02"
                width={14}
                height={14}
                fillColor={color.common.white}
              />
            </Circle>
            {email}
          </a>
        )}
        {phoneNumber && (
          <a href={`tel:${phoneNumber}`} className="phone">
            <Circle>
              <Icon
                id="phone-call-01"
                width={14}
                height={14}
                fillColor={color.common.white}
              />
            </Circle>
            {phoneNumber}
          </a>
        )}
      </Info>
    </Container>
  );
};

export default ContactCard;
